import type { CompoundEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';
import { techdocsRdapClientApiRef } from '../apis/techdocsRdapClient';

export function useTechDocsVersions(entityId: CompoundEntityRef) {
  const client = useApi(techdocsRdapClientApiRef);
  const { value, loading, error, retry } = useAsyncRetry(
    () => client.getVersions(entityId),
    [client, entityId.kind, entityId.namespace, entityId.name],
  );

  return {
    versions: value,
    loading,
    error,
    retry,
  };
}
